import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconRobotServiceMember = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M7.75 10.5C8.16421 10.5 8.5 10.8358 8.5 11.25V14.25C8.5 14.6642 8.16421 15 7.75 15C7.33579 15 7 14.6642 7 14.25V11.25C7 10.8358 7.33579 10.5 7.75 10.5Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.5 11.25C16.5 10.8358 16.1642 10.5 15.75 10.5C15.3358 10.5 15 10.8358 15 11.25V14.25C15 14.6642 15.3358 15 15.75 15C16.1642 15 16.5 14.6642 16.5 14.25V11.25Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.25 15.75C10.25 15.3358 10.5858 15 11 15H12.5C12.9142 15 13.25 15.3358 13.25 15.75C13.25 16.1642 12.9142 16.5 12.5 16.5H11C10.5858 16.5 10.25 16.1642 10.25 15.75Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M11 3C9.48122 3 8.25 4.23122 8.25 5.75V6H7.25C5.17893 6 3.5 7.67893 3.5 9.75V10.5415C2.08114 10.7795 1 12.0135 1 13.5C1 14.9865 2.08114 16.2205 3.5 16.4585V16.75C3.5 18.8211 5.17893 20.5 7.25 20.5H16.25C18.3211 20.5 20 18.8211 20 16.75V16.4585C21.4189 16.2205 22.5 14.9865 22.5 13.5C22.5 12.0135 21.4189 10.7795 20 10.5415V9.75C20 7.67893 18.3211 6 16.25 6H15.75V5.75C15.75 4.23122 14.5188 3 13 3H11ZM14.25 6V5.75C14.25 5.05964 13.6904 4.5 13 4.5H11C10.3096 4.5 9.75 5.05964 9.75 5.75V6H14.25ZM7.25 7.5C6.00736 7.5 5 8.50736 5 9.75V16.75C5 17.9926 6.00736 19 7.25 19H16.25C17.4926 19 18.5 17.9926 18.5 16.75V9.75C18.5 8.50736 17.4926 7.5 16.25 7.5H7.25ZM20 14.9146C20.5826 14.7087 21 14.1531 21 13.5C21 12.8469 20.5826 12.2913 20 12.0854V14.9146ZM2.5 13.5C2.5 12.8469 2.9174 12.2913 3.5 12.0854V14.9146C2.9174 14.7087 2.5 14.1531 2.5 13.5Z",
			fill: "currentColor"
		})
	]
});
export { SvgIconRobotServiceMember as ReactComponent };
